module.exports = __webpack_public_path__ + "img/award-dark.64ad5742.png";